import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { Order } from '@interfaces/OrderTypes';

export interface ScheduledOrdersState {
  orders: Order[];
  count: number;
  isLoaded: boolean;
}

const initialState: ScheduledOrdersState = {
  orders: [],
  count: 0,
  isLoaded: false,
};

export const scheduledOrdersSlice = createSlice({
  name: 'scheduledOrders',
  initialState,
  reducers: {
    initScheduledOrders: (state, action: PayloadAction<Order[]>) => {
      state.orders = action.payload;
      state.count = action.payload.length;
      state.isLoaded = true;
    },

    addScheduledOrder: (state, action: PayloadAction<Order>) => {
      const exists = state.orders.find((o) => o.id === action.payload.id);
      if (exists) return;
      state.orders.push(action.payload);
      state.count = state.orders.length;
    },

    removeScheduledOrder: (state, action: PayloadAction<string>) => {
      state.orders = state.orders.filter((o) => o.id !== action.payload);
      state.count = state.orders.length;
    },

    reset: () => initialState,
  },
});
